/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 13:45 VN — WEB-20261019-suzitee-cart-giftbox-remove-poster (J2)
   Đã làm: popup giữ chân khi xoá add-on nay áp cho MỌI dòng add-on của khối "gift-box" PDP (ảnh có data-sz-addon), không chỉ tên "Gift Box".
   Trước (J 13:05): SP Poster/Canvas có add-on là "Damage-Proof Packaging" (cùng ô tick gift-box trên PDP) → bị loại → bấm xoá là xoá luôn.
   Sau: Poster/Canvas (Damage-Proof), Air Cushion, Writing set, Mesh bag, Embosser đều hỏi; tiêu đề/nút theo đúng tên add-on
   ("Keep your Damage-Proof Packaging?"), gift box giữ y chữ cũ. Thêm đường gõ số lượng 0 (ô qty / Enter submit) cũng hỏi. Chi tiết khối cuối file. */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 12:20 VN — WEB-20261019-suzitee-cart-giftbox-remove-popup
   Đã làm: bấm nút xoá (a.cart-remove-btn) ở dòng GIFT BOX trong giỏ (drawer + trang /cart) → hiện popup giữ chân TRƯỚC khi xoá.
   Trước: xoá ngay, không hỏi. Sau: popup cùng khuôn "View details" gift box (.sz-addon-modal.sz-dpp.sz-gbx, nhân bản từ
   template sz-addon-tpl của chính dòng đó → ảnh hộp thật + câu dẫn + 3 lợi ích đúng họ hộp), tiêu đề "Keep your gift box?",
   2 nút: "Keep my gift box" (đóng, không xoá) / "Remove anyway" (bấm lại ĐÚNG nút xoá gốc của dòng → luồng xoá cũ chạy y hệt).
   ×/nền/Esc = giữ. Chỉ dòng gift box; Damage-Proof/Air Cushion/Writing set/Mesh bag/Embosser và SP chính không đổi.
   Chi tiết ở khối cuối file. */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-18 13:30 VN — WEB-20261018-suzitee-cart-giftbox-link
   Đã làm: link chữ "See what's inside" dưới tên SP dòng add-on (a.sz-addon-see, snippets/sz-cart-line.liquid) mở CÙNG popup như bấm ảnh
   (trước: chỉ ảnh + a.sz-addon-pv). Chỉ thêm selector vào click/phím, logic popup giữ nguyên. */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-18 01:40 VN — WEB-20261018-suzitee-cart-addon-preview
   Đã làm: nút "Preview" mới dưới ảnh dòng add-on (a.sz-addon-pv, snippets/sz-cart-line.liquid) mở CÙNG popup như bấm ảnh add-on
   (trước: chỉ bấm ảnh mới mở). Chỉ mở rộng selector click/phím, logic popup giữ nguyên. */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-18 00:10 VN — WEB-20261017-suzitee-cart-addon-popup (r2)
   Đã làm: bấm ảnh dòng ADD-ON trong GIỎ (drawer + trang /cart) → mở ĐÚNG popup "View details" của trang sản phẩm.
   Trước: drawer mở popup "Preview" chung (chỉ ảnh ghép + nút PROCEED), trang /cart bấm không có gì; r1 (nháp) chép markup Damage-Proof vào JS.
   Sau: KHÔNG có markup trong file này — markup do snippets/sz-addon-modal.liquid (nguồn chung với PDP) render sẵn trong
   <template class="sz-addon-tpl"> cạnh ảnh dòng add-on (snippets/sz-cart-line.liquid, cta:'checkout'); CSS chung assets/sz-addon-modal.css.
   JS chỉ: nhân bản template ra <body>, mở/đóng (×, Esc, bấm nền), nút PROCEED TO CHECKOUT = bấm nút checkout thật của giỏ (không có → /checkout).
   Đóng = gỡ khỏi DOM (không để trùng .content-product-box/.closed-gift-box với popup PDP). Không observer. */
(function () {
  'use strict';
  var cur = null, lastFocus = null;

  var gbxUndo = null; /* J2: đóng popup mà KHÔNG xoá (Keep/×/nền/Esc) khi mở từ ô số lượng = 0 → trả lại số cũ */
  function hide() {
    if (gbxUndo) { var u = gbxUndo; gbxUndo = null; try { u(); } catch (e) {} }
    if (!cur) return;
    var m = cur; cur = null;
    try { m.parentNode && m.parentNode.removeChild(m); } catch (e) {}
    try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* bấm ĐÚNG nút checkout thật của giỏ (giữ mọi hook sẵn có của nút đó); không thấy thì đi thẳng /checkout */
  function checkout() {
    var d = document.documentElement.classList.contains('szmc-open');
    var pick = function (sels) { for (var i = 0; i < sels.length; i++) { var n = document.querySelector(sels[i]); if (n) return n; } return null; };
    var real = d ? pick(['#szmcForm [name="checkout"]', '[form="szmcForm"][name="checkout"]', '#szMdockCheckout'])
                 : pick(['#cart_form #checkout', '#cart_form [name="checkout"]', '#checkout', '#szMdockCheckout']);
    hide();
    if (real) { real.click(); } else { location.href = '/checkout'; }
  }

  function open(a) {
    var line = a.closest('.cart__item') || a.parentNode;
    var tpl = line && line.querySelector('template.sz-addon-tpl');
    if (!tpl || !tpl.content) return false;
    hide();
    var frag = tpl.content.cloneNode(true);
    var m = frag.querySelector('.sz-addon-modal');
    if (!m) return false;
    m.classList.add('sz-addon-modal--cart');
    document.body.appendChild(frag);
    cur = m; lastFocus = a;
    var x = m.querySelector('.closed-gift-box'), go = m.querySelector('.sz-addon-go');
    /* đóng bằng 'click' (không touchend) để cú click đuôi không rơi xuống lớp mờ drawer làm drawer đóng theo */
    m.addEventListener('click', function (e) { if (e.target === m) hide(); });
    if (x) {
      x.setAttribute('role', 'button'); x.setAttribute('tabindex', '0'); x.setAttribute('aria-label', 'Close');
      x.addEventListener('click', function (e) { e.preventDefault(); hide(); });
      x.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hide(); } });
    }
    if (go) go.addEventListener('click', function (e) { e.preventDefault(); checkout(); });
    /* drawer chặn touchmove ngoài vùng cuộn của nó → chặn lan lên để thân popup cuộn được; nền tối thì không cho cuộn xuyên */
    m.addEventListener('touchmove', function (e) { e.stopPropagation(); if (e.target === m) e.preventDefault(); }, { passive: false });
    m.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !x || !go) return;
      var f = [x, go], i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); go.focus(); } else if (!e.shiftKey && i === 1) { e.preventDefault(); x.focus(); }
    });
    m.style.display = 'block';
    try { (x || go).focus({ preventScroll: true }); } catch (e) {}
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a.preview-image[data-sz-addon], a.sz-addon-pv, a.sz-addon-see');
    if (!a) return;
    if (open(a)) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cur) { e.preventDefault(); e.stopPropagation(); hide(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.matches && e.target.matches('a.preview-image[data-sz-addon], a.sz-addon-pv, a.sz-addon-see')) {
      if (open(e.target)) e.preventDefault();
    }
  }, true);

  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 12:20 VN — WEB-20261019-suzitee-cart-giftbox-remove-popup
     Đã làm: popup giữ chân khi xoá GIFT BOX trong giỏ. Nhận diện dòng gift box = ảnh có data-sz-addon (product type "Gift Box",
     sz-cart-line.liquid) + tên SP bắt đầu "Gift Box" (25 SP gift box; Damage-Proof/Air Cushion/Writing/Mesh/Embosser tên khác → không hỏi).
     Bắt ở pha CAPTURE trên document (chạy trước handler xoá của drawer trong sz_minicart.js và trước link /cart/change của trang /cart).
     "Remove anyway" = đặt cờ rồi click lại chính nút xoá → drawer: change.js line=N qty=0 + dọn add-on theo khoá _sz_grp/_addon_for
     + vẽ lại tổng tiền như cũ; trang /cart: đi link /cart/change?line=N&quantity=0 như cũ. Dòng SP chính không bị đụng.
     Lỗi khi dựng popup → không chặn khách, xoá như cũ. CSS nhỏ cho 2 nút chèn 1 lần (id sz-gbx-rm-css), không observer. */
  var GBX_CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var GBX_CSS =
    ':is(#modalViewDetails,.sz-addon-modal).sz-dpp.sz-gbx-rm .sz-gbx-keep{margin:20px 0 0!important;}' +
    ':is(#modalViewDetails,.sz-addon-modal).sz-dpp.sz-gbx-rm .sz-gbx-rmgo{display:block;width:100%;min-height:44px;margin:6px 0 -6px;padding:10px 16px;border:0;border-radius:12px;background:none;cursor:pointer;' +
      'font-family:Poppins,Lato,sans-serif;font-size:14px;font-weight:500;line-height:20px;color:#6b7280;text-align:center;text-decoration:underline;text-underline-offset:3px;text-transform:none;letter-spacing:0;}' +
    ':is(#modalViewDetails,.sz-addon-modal).sz-dpp.sz-gbx-rm .sz-gbx-rmgo:hover,:is(#modalViewDetails,.sz-addon-modal).sz-dpp.sz-gbx-rm .sz-gbx-rmgo:focus-visible{color:#0a1c39;}' +
    ':is(#modalViewDetails,.sz-addon-modal).sz-dpp.sz-gbx-rm .sz-gbx-rm-one{grid-template-columns:1fr!important;max-width:280px;margin-left:auto;margin-right:auto;}' +
    ':is(#modalViewDetails,.sz-addon-modal).sz-dpp.sz-gbx-rm .sz-gbx-rm-one img{aspect-ratio:auto!important;object-fit:contain!important;}';

  /* J2 (13:45 VN): bỏ điều kiện tên "Gift Box" — mọi dòng add-on (data-sz-addon = product type "Gift Box" + Embosser, sz-cart-line.liquid) đều hỏi.
     Án lệ: Hoá thử SP POSTER 13:33 VN → add-on của Poster/Canvas là "Damage-Proof Packaging (Tube / Reinforced Box)" → J bỏ qua. */
  function gbxLine(rm) {
    var line = rm.closest('.cart__item');
    return line && line.querySelector('a.preview-image[data-sz-addon]') ? line : null;
  }
  function gbxTitle(line) {
    var t = line.querySelector('.cart__item--title');
    return ((t && t.textContent) || '').replace(/\s+/g, ' ').trim();
  }
  /* tên ngắn của add-on: tiêu đề popup View details (vd "Damage-Proof Packaging", "Air Cushion Packaging"); không có thì cắt tên SP ở "(" / "–" / "|" */
  function gbxName(line, src) {
    var h = src && src.querySelector('.eb-title-modal'), n = ((h && h.textContent) || '').replace(/\s+/g, ' ').trim();
    if (!n || /add-on combo/i.test(n)) n = gbxTitle(line).split(/\s*[(\u2013\u2014|]|\s-\s/)[0].trim();
    return n || 'add-on';
  }

  function gbxBuild(line) {
    var tpl = line.querySelector('template.sz-addon-tpl');
    /* J2: nguồn = popup View details khuôn Damage-Proof của chính dòng (.sz-dpp: Damage-Proof poster/canvas + mọi .sz-gbx) */
    var src = tpl && tpl.content && tpl.content.querySelector('.sz-addon-modal.sz-dpp');
    var gift = /^gift box\b/i.test(gbxTitle(line)), name = gbxName(line, src);
    var m;
    if (src) {
      m = src.cloneNode(true);
    } else if (!gift) {
      /* J2: add-on không có popup khuôn Damage-Proof (Embosser) → khung tối giản: tiêu đề + ảnh của dòng */
      var th0 = line.querySelector('a.preview-image img') || line.querySelector('img');
      m = document.createElement('div');
      m.className = 'eb-modal eb-modal-reselect-properties-customily content-product-box sz-addon-modal sz-dpp sz-gbx';
      m.innerHTML = '<div class="eb-wrapper-modal"><div class="sz-addon-head"><h2 class="eb-title-modal"></h2>' +
        '<p class="closed-gift-box" role="button" aria-label="Close" tabindex="0">&times;</p></div>' +
        (th0 ? '<div class="sz-dpp-cards sz-gbx-rm-one"><figure class="sz-dpp-card"><img alt="" width="480" height="360" decoding="async"></figure></div>' : '') + '</div>';
      var im0 = m.querySelector('.sz-dpp-card img');
      if (im0 && th0) { im0.src = th0.currentSrc || th0.src; im0.alt = name; }
    } else {
      /* 2 gift box chưa có popup .sz-gbx (16048218276143 / 16136194752815, chờ Hoá) → cùng khuôn, chữ họ "black" mặc định + ảnh của dòng */
      var th = line.querySelector('a.preview-image img') || line.querySelector('img');
      m = document.createElement('div');
      m.className = 'eb-modal eb-modal-reselect-properties-customily content-product-box sz-addon-modal sz-dpp sz-gbx';
      m.innerHTML = '<div class="eb-wrapper-modal"><div class="sz-addon-head"><h2 class="eb-title-modal"></h2>' +
        '<p class="closed-gift-box" role="button" aria-label="Close" tabindex="0">&times;</p></div>' +
        '<p class="sz-dpp-lead">Your gift arrives boxed and ready to hand over &mdash; no wrapping, no last-minute stress.</p>' +
        (th ? '<div class="sz-dpp-cards sz-gbx-rm-one"><figure class="sz-dpp-card"><img alt="Gift box" width="480" height="360" decoding="async"></figure></div>' : '') +
        '<ul class="sz-dpp-list"><li>' + GBX_CHECK + 'A premium unboxing moment</li><li>' + GBX_CHECK + 'Protects your order from bumps in shipping</li><li>' +
        GBX_CHECK + 'Ready to gift &mdash; no wrapping needed</li></ul></div>';
      var im = m.querySelector('.sz-dpp-card img');
      if (im && th) im.src = th.currentSrc || th.src;
    }
    m.id = 'szGbxRemove';
    m.classList.add('sz-addon-modal--cart', 'sz-gbx-rm');
    var w = m.querySelector('.eb-wrapper-modal') || m;
    var h = m.querySelector('.eb-title-modal');
    if (h) { h.id = 'szGbxRemoveTitle'; h.textContent = gift ? 'Keep your gift box?' : 'Keep your ' + name + '?'; m.setAttribute('aria-labelledby', 'szGbxRemoveTitle'); }
    m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
    [].forEach.call(m.querySelectorAll('.sz-gbx-note, .sz-addon-gotit, style'), function (n) { n.parentNode.removeChild(n); });
    var keep = document.createElement('button');
    keep.type = 'button'; keep.className = 'sz-addon-gotit sz-gbx-keep'; keep.textContent = gift ? 'Keep my gift box' : 'Keep ' + name;
    var go = document.createElement('button');
    go.type = 'button'; go.className = 'sz-gbx-rmgo'; go.textContent = 'Remove anyway';
    w.appendChild(keep); w.appendChild(go);
    return m;
  }

  function gbxGo(rm) {
    rm.__szGbxGo = 1;
    try { rm.click(); } finally { rm.__szGbxGo = 0; }
  }

  function gbxAsk(rm, line, undo) {
    hide();
    gbxUndo = undo || null;
    if (!document.getElementById('sz-gbx-rm-css')) {
      var st = document.createElement('style'); st.id = 'sz-gbx-rm-css'; st.textContent = GBX_CSS; document.head.appendChild(st);
    }
    var m = gbxBuild(line);
    document.body.appendChild(m);
    cur = m; lastFocus = rm;
    var x = m.querySelector('.closed-gift-box'), keep = m.querySelector('.sz-gbx-keep'), go = m.querySelector('.sz-gbx-rmgo');
    m.addEventListener('click', function (e) { if (e.target === m) hide(); });
    if (x) {
      x.addEventListener('click', function (e) { e.preventDefault(); hide(); });
      x.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hide(); } });
    }
    keep.addEventListener('click', function (e) { e.preventDefault(); hide(); });
    go.addEventListener('click', function (e) { e.preventDefault(); gbxUndo = null; hide(); gbxGo(rm); });
    m.addEventListener('touchmove', function (e) { e.stopPropagation(); if (e.target === m) e.preventDefault(); }, { passive: false });
    m.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = [x, keep, go].filter(Boolean), i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    });
    m.style.display = 'block';
    try { keep.focus({ preventScroll: true }); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var rm = e.target && e.target.closest && e.target.closest('a.cart-remove-btn');
    if (!rm || rm.__szGbxGo) return;
    var line = gbxLine(rm);
    if (!line) return;
    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    try { gbxAsk(rm, line); } catch (err) { hide(); gbxGo(rm); }
  }, true);

  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 13:45 VN — WEB-20261019-suzitee-cart-giftbox-remove-poster (J2)
     Đã làm: đường xoá thứ 2 = gõ số lượng 0 vào ô qty của dòng add-on (drawer: sự kiện change → change.js qty 0; /cart: Enter/Update gửi updates[]=0).
     Trước: xoá thẳng. Sau: cùng popup; Keep/×/nền/Esc → trả ô về số cũ, không xoá; "Remove anyway" → bấm nút xoá gốc của dòng (luồng cũ).
     Nút "−" KHÔNG cần: drawer + /cart đều chặn ở 1 (sz_minicart.js "ve 0 thi dung nut thung rac"). Xoá SP chính kéo add-on theo = code, không click → không hỏi. */
  function gbxQty(inp) {
    if (!inp || !inp.closest) return null;                 /* change của ô khác (checkbox PDP, Customily…) → bỏ qua */
    var line = inp.closest('.cart__item');
    var rm = line && line.querySelector('a.cart-remove-btn');
    var v = parseInt(inp.value, 10);                       /* rỗng/NaN = không xoá (drawer coi rỗng là 1) */
    if (!rm || !gbxLine(rm) || !(v < 1)) return null;
    return { inp: inp, line: line, rm: rm };
  }
  function gbxQtyAsk(q) {
    var prev = q.inp.__szGbxPrev || q.inp.getAttribute('value') || '1';
    if (!(parseInt(prev, 10) > 0)) prev = '1';
    try { gbxAsk(q.rm, q.line, function () { q.inp.value = prev; }); } catch (err) { hide(); gbxGo(q.rm); }
  }
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('.cart__item input.quantity') && parseInt(t.value, 10) > 0) t.__szGbxPrev = t.value;
  }, true);
  document.addEventListener('change', function (e) {
    var q = gbxQty(e.target && e.target.matches && e.target.matches('input.quantity') ? e.target : null);
    if (!q) return;
    e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (cur && cur.id === 'szGbxRemove') return;
    gbxQtyAsk(q);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target, ins = f && f.querySelectorAll ? f.querySelectorAll('.cart__item input.quantity') : [];
    for (var i = 0; i < ins.length; i++) {
      var q = gbxQty(ins[i]);
      if (!q) continue;
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (!(cur && cur.id === 'szGbxRemove')) gbxQtyAsk(q);
      return;
    }
  }, true);
})();
